
import { defineComponent, PropType } from "@vue/runtime-core";
import TextEditor from "@/components/ui/TextEditor.vue";
import { Exercise, EventParticipationSlotSubmission, getEmptySubmission } from "@/models";
import AbstractExercise from "./AbstractExercise.vue";
import { exerciseProps } from "./shared";
import ProcessedTextFragment from "@/components/ui/ProcessedTextFragment.vue";
import { useMetaStore } from "../../../stores/metaStore";
import { mapStores } from "pinia";
import Avatar from "../../ui/Avatar.vue";
export default defineComponent({
	name: "OpenAnswerExercise",
	props: {
		...exerciseProps,
	},
	methods: {},
	computed: {
		...mapStores(useMetaStore),
		isAnswerTextParsedObject(): boolean {
			try {
				const parsed = JSON.parse(this.submission.answer_text);
				return typeof parsed === "object" && parsed !== null;
			} catch (e) {
				return false;
			}
		},
		parsedAnswerText() {
			try {
				const parsed = JSON.parse(this.submission.answer_text);
				return parsed;
			} catch (e) {
				return null;
			}
		},
		answerTextProxy: {
			get() {
				return this.submission.answer_text;
			},
			set(val: string) {
				this.$emit("updateSubmission", ["answer_text", val]);
			},
		},
	},
	components: { Avatar, TextEditor, AbstractExercise, ProcessedTextFragment },
});
